// extracted by mini-css-extract-plugin
module.exports = {"tile":"VictimInformation_tile__3Anyd","CheckboxInput":"VictimInformation_CheckboxInput__3HNc_","subHeadingInfo":"VictimInformation_subHeadingInfo__2MsGI"};